import Transformer from '@/transformers/transformer'

import moment from 'moment'
moment.locale('es-mx')

const supplyTransformer = function ({
  id, amount, price_unit: unitPrice, supply_name: supplyName,
  total, um, rejected, code
}) {
  return {
    id,
    amount,
    unitPrice,
    supplyName,
    total,
    um,
    rejected,
    code
  }
}

export default class requisitionsTransformer extends Transformer {
  static fetch({
    highway, sinister_number: sinisterNumber, date_sinister: sinisterDate,
    supplies, type_sinister: sinisterType 
  }) {
    return {
      highway,
      sinisterNumber,
      sinisterDate: moment(sinisterDate).format('DD/MM/YYYY'),
      requisitionSupplies: supplies.length > 0 ? supplies.map(supplyTransformer) : [],
      sinisterType
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/returnedAmounts.js